import React from 'react'
import MessageModal from '../MessageModal/MessageModal'
import PropTypes from 'prop-types'
import AppRoutes from '../../routes/appRoutes'
import { useHistory } from 'react-router-dom'

const ReviewRequestBanner = ({ setShowReviewRequestBanner }) => {
    const history = useHistory()

    const handleReviewRequests = () => {
        handleContinue()
        history.push(`${AppRoutes.requests()}?activeTab=activeRequests`)
    }

    const handleContinue = () => {
        setShowReviewRequestBanner(false)
        localStorage.setItem('reviewRequestsShown', 'false')
    }

    return (
        <MessageModal
            isOpen={true}
            title="Data not synced"
            message={
                'One or more of your requests encountered an error during the sync process. Please review and resubmit them.'
            }
            textDone={'Continue'}
            onDone={handleContinue}
            textCancel={'Review Requests'}
            onCancel={handleReviewRequests}
            maxWidth="xl"
        />
    )
}

ReviewRequestBanner.propTypes = {
    setShowReviewRequestBanner: PropTypes.func.isRequired,
}

export default ReviewRequestBanner
